const data: any = {
  rt: {
    "b": {
      "thisOpponent": "diesen Gegner",
      "firstMatch": "Erstes Spiel",
      "lastMatch": "Letztes Spiel · {{value}}",
      "oneRated": "gegen {{name}} {{value}} · 1 bewertetes Spiel",
      "average": "gegen {{name}} {{value}} · {{count}} Spiele",
      "oneRatedMe": "gegen mich {{value}} · 1 bewertetes Spiel",
      "averageMe": "gegen mich {{value}} · {{count}} Spiele",
      "comparisonControls": "Historische Vergleiche",
      "showH2H": "Durchschnitt aus direkten Duellen",
      "showOverall": "Gesamtdurchschnitt aus allen Spielen"
    },
    "f": {
      "shot_accuracy": "Schlaggenauigkeit",
      "call_accuracy": "Genauigkeit der eigenen Aus-Entscheidungen",
      "confrontational_tendency": "Konfrontationsneigung",
      "forehand": "Vorhand",
      "backhand": "Rückhand",
      "service": "Aufschlag",
      "return": "Return",
      "volley": "Volley",
      "smash": "Schmetterball",
      "drop_shot": "Stoppball",
      "lob": "Lob",
      "stamina": "Ausdauer",
      "speed": "Schnelligkeit",
      "court_coverage": "Platzabdeckung",
      "tactics": "Taktik",
      "awareness": "Spielübersicht",
      "shot_variety": "Schlagvielfalt",
      "winners": "Winner",
      "unforced_errors": "Unerzwungene Fehler",
      "fh_topspin": "Vorhand Topspin",
      "fh_slice": "Vorhand Slice",
      "bh_topspin": "Rückhand Topspin",
      "bh_slice": "Rückhand Slice",
      "first_serve": "Erster Aufschlag",
      "first_serve_speed": "Tempo 1. Aufschlag",
      "second_serve": "Zweiter Aufschlag",
      "second_serve_speed": "Tempo 2. Aufschlag",
      "serve_flat": "Flacher Aufschlag",
      "serve_kick": "Kick-Aufschlag",
      "serve_slice": "Slice-Aufschlag",
      "first_serve_pct_est": "Erste Aufschläge drin (geschätzt)",
      "second_serve_pct_est": "Zweite Aufschläge drin (geschätzt)",
      "passing_shots": "Passierschlag",
      "volley_d": "Volley",
      "tactics_d": "Taktik",
      "speed_d": "Schnelligkeit",
      "stamina_d": "Ausdauer",
      "composure": "Nervenstärke",
      "concentration": "Konzentration",
      "calmness": "Ruhe",
      "anxiety": "Nervosität",
      "confidence": "Selbstvertrauen",
      "fighting_spirit": "Kampfgeist",
      "mental_resilience": "Mentale Widerstandskraft",
      "belief_pre": "Siegesglaube vor dem Match",
      "belief_in": "Siegesglaube während des Matches"
    },
    "g": {
      "movement": "Bewegung & Stellungsspiel",
      "behaviour": "Verhalten",
      "forehand": "Vorhand",
      "backhand": "Rückhand",
      "serve": "Aufschlag",
      "rally": "Grundlinie & Return",
      "net": "Netzspiel",
      "physical": "Physis & Taktik"
    },
    "h": {
      "shot_accuracy": "Wie konstant landeten deine Schläge dort, wo du sie haben wolltest?",
      "call_accuracy": "Wie treffsicher waren deine eigenen Aus-Entscheidungen?",
      "confrontational_tendency": "Neigung zu Diskussionen, Spannungen oder Konfrontationen mit dem Gegner."
    },
    "dist": {
      "winnersIncl": "Winner (inkl. Asse)",
      "unforcedIncl": "Unerzwungene Fehler (inkl. Doppelfehler)",
      "assignTo": "Restliche {{n}} % zuweisen an…",
      "countHint": "Du hast {{a}} Asse und {{d}} Doppelfehler erfasst.",
      "remainingInline": "Rest {{n}} %",
      "complete": "Vollständig — 100 % verteilt",
      "assignRemainder": "Restliche {{n}} % hier zuweisen",
      "tab": "Punkte",
      "title": "Wie endeten die Punkte?",
      "helper": "Deine eigene Schätzung — kein Punkt-für-Punkt-Zählen nötig. Ungefähre Werte genügen, du kannst es auch leer lassen.",
      "winners": "Winner",
      "forced": "Erzwungene Fehler",
      "unforced": "Unerzwungene Fehler",
      "df": "Doppelfehler",
      "total": "Gesamt",
      "remaining": "{{n}}% nicht zugeordnet",
      "over": "{{n}}% über 100",
      "myTeam": "Mein Team",
      "oppTeam": "Gegnerisches Team"
    }
  },
  onboarding: {
    eyebrow: "Loslegen",
    valueHistory: "Baue deine komplette Match-Historie auf",
    valueStats: "Verstehe deine Statistiken",
    valueImprove: "Verfolge deine Fortschritte über die Zeit",
    showMore: "So funktioniert’s & Funktionen",
    showLess: "Weniger anzeigen",
    headlineDashboard: "Dein Dashboard wartet auf das erste Match",
    headlineMatches: "Trag ein Match ein und starte deine Tennis-Historie",
    headlineStats: "Statistiken schalten sich nach dem ersten Match frei",
    intro: "Tennis Log macht aus jedem Match Erkenntnisse. Trag das erste in unter einer Minute ein und sieh, wie Dashboard, Diagramme und KI-Coach lebendig werden.",
    cta: "+ Erstes Match eintragen",
    howTitle: "So funktioniert's",
    s1Title: "Match hinzufügen",
    s1Desc: "Tippe „Neues Match\", trage Datum, Gegner, Platz und Satzergebnisse ein. Drop-downs machen es schnell.",
    s2Title: "Details ergänzen (optional)",
    s2Desc: "Spiel für Spiel, Bedingungen, Doppelfehler, Bewertungen — so tief du willst, oder nur das Ergebnis.",
    s3Title: "Statistiken sehen",
    s3Desc: "Siegquote, Hold-Rate, Break-Rate, Sätze, Spiele, Belag, Platz, Gegner — alles sofort aktualisiert.",
    s4Title: "KI-Insights erhalten",
    s4Desc: "Die KI-Analyse ist verfügbar, sobald du Matchdaten erfasst hast, und wird im Allgemeinen aussagekräftiger, wenn dein Matchverlauf wächst.",
    benefitsTitle: "Was du nach deinen Matches siehst",
    b1Title: "Gesamt-Siegquote",
    b1Desc: "Nach Jahr, Format (Einzel/Doppel/Mixed) und Art (Freundschaft/Offiziell). Sieh Trends pro Saison.",
    b2Title: "Sätze, Spiele, Hold & Break",
    b2Desc: "Mehr als S/N: wie oft hältst du Aufschlag, wie oft brichst du, Satz- und Spieldifferenz.",
    b3Title: "Smartwatch-Statistiken",
    b3Desc: "Lade einen Screenshot aus Mi Fitness, Garmin, Apple Watch oder Zepp — KI füllt Kalorien, BPM und HF-Zonen.",
    b4Title: "Spiel-für-Spiel-Heatmap",
    b4Desc: "Sieh, ob du bei Spiel 3 zerbrichst oder Spiel 11 sicher abschließt — nach Aufschlagseite und Satz.",
    b5Title: "Leistungsbewertungen",
    b5Desc: "Bewerte Vorhand, Rückhand, Aufschlag, Return, Volley, Übersicht, Platzabdeckung. Als Radar-Chart.",
    b6Title: "KI-Coach",
    b6Desc: "Eine persönliche Erzählung deiner Stärken, Schwächen und Muster — geschrieben wie von einem Coach.",
    tipsTitle: "Tipps für den ersten Eintrag",
    tip1: "Klein anfangen: Datum, Gegner und Sätze reichen.",
    tip2: "Platz und Belag dazu — mit der Zeit siehst du, wo du am besten spielst.",
    tip3: "Probiere einen Satz Spiel für Spiel, um Hold-Rate und Heatmaps freizuschalten.",
    tip4: "Bewerte dich ehrlich — wenige Einträge nähren schon die KI.",
    tip5: "Alte Matches? Trag sie auch ein. Geschichte macht die Statistik.",
  },
  nav: { dashboard: "Dashboard", matches: "Spiele", add: "Neues Spiel", stats: "Stats", insights: "KI-Insights", logout: "Abmelden" , settings: "Einstellungen", invite: "Freund einladen" },
  brand: { name: "My Tennis Ledger", tagline: "Werde besser, indem du deine Tennishistorie studierst" },
  auth: { age16: "Ich bestätige, dass ich mindestens 16 Jahre alt bin. Tennis-Log-Konten sind für Personen ab 16 Jahren.", age16Required: "Bitte bestätige, dass du mindestens 16 Jahre alt bist.", signIn: "Anmelden", signUp: "Registrieren", email: "E-Mail", password: "Passwort", name: "Name", createAccount: "Konto erstellen", or: "oder", continueGoogle: "Mit Google fortfahren", welcomeBack: "Willkommen zurück!", accountCreated: "Konto erstellt!", passwordInfoLabel: "Passwortanforderungen", passwordHelp: "Verwende mindestens 8 Zeichen. Großbuchstaben, Zahlen oder Sonderzeichen sind nicht erforderlich, vermeide aber sehr häufige oder leicht zu erratende Passwörter. Passwörter aus bekannten Datenlecks werden nicht akzeptiert.", passwordTooShort: "Das Passwort muss mindestens 8 Zeichen lang sein.", passwordWeakLeaked: "Dieses Passwort ist zu häufig oder tauchte in einem bekannten Datenleck auf. Wähle ein individuelleres Passwort.", passwordRejected: "Dieses Passwort wurde nicht akzeptiert. Prüfe die Anforderungen neben dem Feld und versuche es erneut.", passwordMinLabel: "Mindestens 8 Zeichen", requirementMet: "Anforderung erfüllt", requirementNotMet: "Anforderung noch nicht erfüllt", sameMethodHint: "Verwende dieselbe Anmeldemethode, mit der du dein Konto erstellt hast.", signInFailed: "E-Mail oder Passwort ist falsch. Wenn du dein Konto mit Google erstellt hast, melde dich mit Google an." },
  authPage: {
    heroTitle: "Beginne, deine Tennisgeschichte aufzubauen",
    heroSubtitle: "Erfasse Matches in wenigen Minuten, erkenne deine Muster und lass deine Statistiken zeigen, was du als Nächstes verbessern kannst.",
    trustFree: "Kostenlose Kernfunktionen",
    trustData: "Deine Daten bleiben deine",
    trustDevice: "Funktioniert auf Handy und Web",
    dashboardAlt: "Tennis Log Dashboard mit Siegquote, Sätzen, Games und Aufschlagquote",
    dashboardCaption: "Nach wenigen Matches zeigt dein Dashboard Siegquote, Aufschlagquote, Breakbälle, Trends und AI-Insights.",
    founderQuote: "Ich habe Tennis Log entwickelt, weil ich aufhören wollte, meine eigenen Matches zu vergessen. Alles was du brauchst: spielen, dich an den Spielverlauf erinnern und ihn festhalten. Ich bin sicher, es wird auch dir nützlich sein. Viel Spaß!",
    founderTitle: "Gründer von Tennis Log — My Tennis Ledger",
    founderLocation: "Fortgeschrittener Clubspieler, Griechenland",
    notReadyTitle: "Noch nicht bereit zur Anmeldung?",
    notReadySub: "Erkunde zuerst die öffentlichen Inhalte — alles offen, kein Konto nötig.",
    viewDemoTitle: "Öffentliche Demo ansehen",
    viewDemoDesc: "Sieh, was Tennis Log nach ~25 Matches zeigt — mit echten Charts.",
    readGuideTitle: "Tennis-Statistik-Leitfaden lesen",
    readGuideDesc: "Welche Statistiken wirklich zählen und wie man sie liest.",
    browseBlogTitle: "Blog durchstöbern",
    browseBlogDesc: "Artikel zu Hold/Break, Siegquoten-Trend, Smartwatch, AI-Insights und Mental Game.",
    open: "Öffnen",
  },
  common: {
    all: "Alle", singles: "Einzel", doubles: "Doppel", mixed: "Mixed",
    friendly: "Freundschaftlich", official: "Offiziell",
    me: "Ich", opponent: "Gegner", year: "Jahr", draw: "Unentschieden",
    cancel: "Abbrechen", save: "Speichern", saving: "Speichern...", loading: "Lädt...",
    delete: "Löschen", edit: "Bearbeiten", search: "Suchen", close: "Schließen",
    matches: "Spiele", other: "Andere (angeben)",
    loadFailed: "Deine Daten konnten nicht geladen werden", loadFailedBody: "Beim Laden ist etwas schiefgelaufen. Prüfe deine Verbindung und versuche es erneut.", retry: "Erneut versuchen",
  },
  conditions: { sun: "Sonne im Gesicht", wind: "Wind", noise: "Lärm / Publikum", cold: "Kälte", rain: "Regen", slippery: "Rutschiger Platz", humidity: "Luftfeuchtigkeit", strong_wind: "Starker Wind" },
  dashboard: {
    title: "Dashboard", subtitle: "Deine Saison auf einen Blick.",
    newMatch: "+ Neues Spiel", statsFilter: "Stats-Filter", trendFilter: "Trend-Filter",
    trendTitle: "Siegquoten-Trend", recent: "Letzte Spiele", seeAll: "Alle →",
    noMatches: "Noch keine Spiele.", addFirst: "Erstes hinzufügen",
    noFilter: "Keine Spiele für diesen Filter.",
    overallWinRate: "Gesamtsiegquote", winRate: "Siegquote", clickDot: "Klick zum Bearbeiten", sets: "Sätze", games: "Games", holdRate: "Hold-Quote",
    breaksWon: "Breaks gewonnen", breaksWonSub: "{{breaks}} von {{total}} Return-Games",
    serviceGames: "Aufschlagspiele", returnGames: "Return-Games",
    winAfterFirstSet: "Sieg nach gewonnenem 1. Satz", winAfterFirstSetSub: "{{wins}} von {{total}} Matches", surfaceFilter: "Belag",
    setsWon: "Gewonnene Sätze", gamesWon: "Gewonnene Games", breakRate: "Break-Quote",
    currentForm: "Aktuelle Form", formEmpty: "Noch keine abgeschlossenen Spiele",
    trendDelta: "Siegquote {{pp}} Pp vs. vorherige 10",
    trendStable: "Siegquote stabil vs. vorherige 10",
    trendUnavailable: "Trend ab {{count}} Spielen verfügbar",
    discovery: {
      title: "Was dir dein Tennis sagt",
      family: { improving: "Verbesserung", edge: "Deine Stärke", watch: "Achtung" },
    },
  },
  match: {
    opponentPrivacyHint: "Optional. Diese Angaben betreffen eine andere Person – notiere nur, was deiner Analyse hilft, und bleibe sachlich.",
    basics: "Basis", players: "Spieler", score: "Ergebnis pro Satz",
    invalidSetScore: "Unmögliches Ergebnis in Satz {{set}} — der Sieger muss das Ziel erreichen und mit 2 führen.", notes: "Notizen",
    watch: "Smartwatch-Daten", rating: "Spielbewertung (1–10)",
    surface: "Belag", temperature: "Temperatur ({{unit}})",
    setType: "Satztyp", standardSet: "Standard", shortSet: "Short Set (bis 4 Games)", superTb: "Super TB (10p)", tb7: "Tiebreak 7p", tb11: "Tiebreak 11p",
    tbPointByPoint: "Punkt für Punkt", tbUndo: "Rückgängig", tbClear: "Löschen", tbDecided: "Entschieden",
    date: "Datum", time: "Uhrzeit", day: "Tag", court: "Platz", courtCustomPlaceholder: "z.B. Club Court #1",
    format: "Format", kind: "Art",
    set: "Satz", firstServer: "Erster Aufschlag:",
    missingOpponent: "Gib den Namen des Gegners ein, um das Match zu speichern.", missingCourt: "Gib den Namen des Platzes ein, um das Match zu speichern.",
    opponentRequired: "Gegner *", myPartner: "Mein Partner", oppPartner: "Gegnerpartner",
    teams: "Teams", teamsHint: "Mein Team (ich + Partner) gegen gegnerisches Team (Gegner 1 + Gegner 2).",
    myTeam: "Mein Team",
    opponentTeam: "Gegnerteam",
    opponent1: "Gegner 1",
    opponent2: "Gegner 2",
    doublesPlayersRequired: "Gib deinen Partner und beide Gegner ein, um das Doppel zu speichern.",
    age: "Alter", experience: "Erfahrungsjahre", backhand: "Rückhand", playstyle: "Spielstil",

    notesPlaceholder: "Wie lief das Spiel?",
    summaryTab: "Zusammenfassung", detailedTab: "Detailliert",
    watchHint: "Lade Mi Fitness/Garmin/Apple Watch Screenshot hoch — auto-fill per KI.",
    ratingHint: "Lass leer, was du nicht bewerten willst.",
    saveMatch: "Speichern", saveChanges: "Speichern",
    addTitle: "Neues Spiel", addSubtitle: "Details ausfüllen.",
    editTitle: "Spiel bearbeiten", editSubtitle: "Aktualisieren und speichern.",
    saved: "Spiel gespeichert!", changesSaved: "Änderungen gespeichert!", notFound: "Spiel nicht gefunden",
    retired: "Gab es eine Aufgabe?", retiredNone: "Nein", retiredYes: "Ja", retiredMe: "Ich habe aufgegeben", retiredOpp: "Gegner hat aufgegeben",
    specialEnding: "Besonderes Spielende",
    scoreMismatchTitle: "Das Ergebnis stimmt nicht überein",
    scoreMismatchBody: "Aus dem erfassten Spielverlauf ergibt sich {{derived}}, im Endergebnis steht aber {{declared}}. Bitte vor dem Fortfahren prüfen.",
    scoreMismatchFix: "Endergebnis korrigieren",
    declaredScore: "Angegebenes Ergebnis",
    declaredScoreHint: "Das ist das Endergebnis aus Schritt 1. Zeige jetzt, wie der Satz verlaufen ist.",
    declaredScorePrompt: "Du hast angegeben, dass <highlight>Satz {{set}} {{score}} endete</highlight>. Zeige jetzt, wie sich der Spielstand entwickelt hat.",
    incompleteSetTimePrompt: "Du hast angegeben, dass <highlight>Satz {{set}} bis {{score}} gespielt wurde</highlight>, aber nicht abgeschlossen wurde, wahrscheinlich weil die Zeit abgelaufen ist. Trage nur die gespielten Games ein, damit sie im Elo berücksichtigt werden.",
    timelineLiveScore: "Laufender Spiel-für-Spiel-Stand",
    scoreMismatchBlock: "Der Spiel-für-Spiel-Verlauf stimmt nicht mit dem Endergebnis überein. Bitte korrigiere die Abweichung, bevor du fortfährst.",
    gameSequenceNext: "Games der Reihe nach eingeben · Als Nächstes: Game {{game}}",
    gameSequenceGap: "Game {{missing}} fehlt vor Game {{later}}. Trage es zuerst ein.",
    gameSequenceBlock: "Vervollständige die fehlenden Games der Reihe nach, bevor du fortfährst.",
    doubleFaults: "Doppelfehler",
    dfMe: "Meine Doppelfehler",
    dfOpp: "Doppelfehler Gegner",
    aces: "Asse",
    acesMe: "Meine Asse",
    acesOpp: "Asse Gegner",
    context: "Kontext & Bedingungen",
    contextHint: "Äußere und persönliche Faktoren, die das Spiel beeinflusst haben.",
    conditions: "Physische Bedingungen",
    personalIssues: "Persönliche Schwierigkeiten",
    personalIssuesPlaceholder: "z. B. Kopfschmerzen, Knieschmerz, Müdigkeit…",
    psychTab: "Psychologie",
    oppAge: "Alter des Gegners",
    oppBackhand: "Rückhand des Gegners",
    bhSingle: "Einhändig",
    bhDouble: "Beidhändig",
    oppPlaystyle: "Spielstil",
    styleOffensive: "Offensiv",
    styleDefensive: "Defensiv",
    styleAllCourt: "Allcourt",
    floodlights: "Unter Flutlicht",
    rainy: "Regenwetter",
    tiringDay: "Anstrengender Tag / harter Arbeitstag",
    napped: "Mittagsschlaf",
    heavyMeal: "Schwere Mahlzeit",
    fasted: "Nüchtern",
    anxiousFlag: "Ängstlich",
    tournamentRound: "Turnierrunde",
    tournamentName: "Turniername",
    sleepHours: "Schlaf letzte Nacht (Std.)",
    ballsState: "Ballzustand",
    ballsNew: "Neu", ballsUsed: "Gebraucht",
    ballsUseCount: "Wie oft benutzt",
    ballsUseSuffix: "x",
    oppExperience: "Jahre Erfahrung",
    racketStrungAt: "Schläger bespannt am",
    racketStrungAgo: "vor {{n}} Tagen",
    racketStrungToday: "heute",
    individualConditions: "Persönliche Bedingungen",
    daysSinceLastMatch: "Tage seit letztem Spiel",
    daysAgo: "vor {{n}} Tagen",
    ballsUsed1: "1x benutzt", ballsUsed2: "2x benutzt", ballsUsed3: "3x benutzt",
    oppHandedness: "Händigkeit", righty: "Rechtshänder", lefty: "Linkshänder",
    weightKg: "Gewicht ({{unit}})", bmi: "BMI", bmiNoHeight: "Hinterlege deine Größe im Profil, um den BMI zu berechnen",
    hLegend: "H = Hold", bLegend: "B = Break",
    cellHowTo: "Ein Klick auf das Feld des Aufschlägers für Hold (H), Doppelklick für Break (B). Ein weiterer Klick leert das Feld.",
    gameDetail: {
      toggle: "Spieldetails erfassen",
      toggleHint: "Optional: Tippe auf ein beendetes Game und erfasse, welchen Punktestand der Verlierer erreichte.",
      gameN: "Spiel {{n}}",
      openSheet: "Detail hinzufügen",
      youServed: "du hast aufgeschlagen", oppServed: "Gegner hat aufgeschlagen",
      held: "Hold", wasBroken: "du wurdest gebreakt", oppHeld: "Hold des Gegners", youBroke: "du hast gebreakt",
      question: "Wie weit kam der Verlierer des Spiels?",
      deuce: "Einstand",
      gamePointQuestion: "Hatte der Verlierer einen Spielball?",
      yes: "Ja", no: "Nein",
      clearDetail: "Detail löschen", changeResult: "Ergebnis ändern",
      hold: "Hold", break: "Break", clearResult: "Ergebnis löschen",
      token: { "0": "Kam bis 0", "15": "Kam bis 15", "30": "Kam bis 30", D: "Einstand, ohne Spielball", DG: "Einstand, mit Spielball" },
    },
  },
  matches: {
    title: "Spiele", subtitle: "Deine gesamte Historie.",
    searchOpponent: "Gegner suchen", searchPlaceholder: "z.B. Müller",
    format: "Format", confrontation: "Art",
    matchesCount: "{{count}} Spiele",
    none: "Keine Spiele", new: "+ Neu",
    setGameByGame: "Satz {{n}} — Spiel für Spiel",
    confirmDelete: "Spiel löschen? Nicht rückgängig.",
    deleted: "Gelöscht",
    singular: "Einzel", duplet: "Doppel", official: "Offiziell", friendly: "Freundschaftlich",
  },
  stats: {
    perGameSelectionDetails: "{{wins}} erfolgreiche von {{total}} erfassten Games",
    trendSelectedMatch: "Ausgewähltes Match",
    trendOpenMatch: "Match ansehen",
    tempStepLabel: "Temperaturintervall (°C)",
    ageStepLabel: "Altersintervall (Jahre)",
    experienceStepLabel: "Erfahrungsintervall (Jahre)",
    byMyBmiHint: "BMI = Gewicht (kg) / Größe² (m²). Basiert auf der Profilgröße und dem Gewicht pro Match.",
    byMyBmiNone: "Keine eigenen BMI-Werte. Größe in den Einstellungen und Gewicht pro Match eintragen.",
    bmiBucketSize: "BMI-Intervall",
    bmiSmallSampleHint: "Balken antippen: Siege und Matches. Sehr enge Intervalle mit wenigen Matches erlauben keine belastbaren Schlüsse.",
    startTimeHalfHourHint: "Nach halbstündigen Startzeitfenstern (18:30 umfasst 18:30–18:59).",
    title: "Stats", subtitle: "Tauche tief in die Zahlen ein.",
    none: "Keine Spiele mit Ergebnis.",
    allOpponents: "Alle Gegner",
    gamesIServed: "Eigene Aufschlagspiele", holdRateOnServe: "Hold-Quote bei eigenem Aufschlag",
    gamesIReceived: "Return-Games", opponentHolds: "Holds des Gegners", breaksIDid: "Erzielte Breaks",
    serviceStats: "Aufschlag-Stats", returnStats: "Return-Stats",
    holds: "Holds", breaksAgainst: "Breaks (gegen mich)", holdRate: "Hold-Quote ({{n}} Games)",
    breaksWon: "Breaks gewonnen", breakRate: "Break-Quote ({{n}} Return-Games)",
    smartwatch: "Smartwatch-Stats", smartwatchHint: "Durchschnitte aus deinen Screenshots.",
    avgKcal: "Ø Kalorien", avgDuration: "Ø Dauer", avgBpm: "Ø BPM", maxBpm: "Max BPM (Ø)",
    perfReport: "Performance-Report",
    perfHint: "Durchschnittliche Bewertungen (1–10).",
    perfNone: "Noch keine Bewertungen.",
    trendTitle: "Siegquoten-Trend", h2h: "Direkter Vergleich",
    byCourt: "Siegquote pro Platz", byDay: "Pro Tag",
    bySurface: "Pro Belag", byTemp: "Pro Temperatur",
    surfaceNone: "Kein Belag erfasst.", tempNone: "Keine Temperatur erfasst.",
    perGame: "Erfolg pro Game", set: "Satz", scope: "Sichtweise",
    scopeAll: "Gesamt", scopeServing: "Mit Aufschlag begonnen", scopeReturning: "Mit Return begonnen",
    metricWin: "Siegquote", metricHold: "Hold-Quote (am Aufschlag)",
    fullTab: "Komplett", allSet: "Alle Sätze",
    perGameHint: "Erfolgsquote pro Game-Nummer.",
    firstBreakTitle: "Siegquote nach erstem Break", firstBreakHint: "Entscheidet das erste Break das Ergebnis?",
    fbMe: "Ich habe zuerst gebreakt", fbOpp: "Gegner hat zuerst gebreakt", allSurfaces: "Alle Beläge",
    firstServerTitle: "Siegquote nach erstem Aufschläger", firstServerHint: "Beeinflusst der erste Aufschlag dein Ergebnis?",
    fsMatch: "Ganzes Match", fsMe: "Ich begann aufzuschlagen", fsOpp: "Gegner begann aufzuschlagen",
    returnGames: "Return-Games", breakRateLabel: "Break-Quote", gameNumber: "Game",
    hrZonesAvg: "Durchschnittliche Herzfrequenzzonen",
    hrZonesAvgHint: "Durchschnittliche Minuten pro Zone aus {{n}} Spielen mit Uhr-Daten.",
    byYear: "Siegquote pro Jahr", byMonth: "Siegquote pro Monat",
    byCategoryKind: "Siegquote nach Kategorie & Art",
    byOppAge: "Nach Alter des Gegners", byOppAgeHint: "Nach Altersgruppe.", byOppAgeNone: "Kein Gegner-Alter erfasst.",
    byOppExp: "Nach Erfahrung des Gegners", byOppExpHint: "Tennis-Jahre.", byOppExpNone: "Keine Erfahrung erfasst.",
    byOppLevel: "Siegquote nach Gegnerstärke", byOppLevelHint: "Gesamtniveau des Gegners (1–10).", byOppLevelNone: "Noch kein Gegnerniveau erfasst.",
    byOppBmi: "Nach BMI des Gegners", byOppBmiHint: "Body-Mass-Index = Gewicht (kg) / Größe² (m²).", byOppBmiNone: "Kein Gegner-BMI erfasst. Größe und Gewicht des Gegners eingeben.",
    showTrend: "Trend anzeigen", hideTrend: "Trend ausblenden",
    byOppBackhand: "Nach Rückhand des Gegners", byOppBackhandNone: "Keine Rückhand erfasst.",
    byBalls: "Nach Ballzustand", byBallsNone: "Kein Ballzustand erfasst.",
    ballsNew: "Neu", ballsUsed: "Gebraucht", ballsUsedN: "Gebraucht ×{{count}}",

    byRainy: "Bei Regen", byFloodlights: "Mit Flutlicht",
    byDuration: "Nach Spieldauer", byStartTime: "Nach Startzeit",
    byMyBmi: "Nach meinem BMI",
    byOppHandedness: "Nach Händigkeit des Gegners", byOppPlaystyle: "Nach Spielstil des Gegners",
    byOppBirthMonth: "Siegquote nach Geburtsmonat des Gegners",
    bySleep: "Nach Schlafstunden", byTiringDay: "Nach anstrengendem Tag",
    byNapped: "Mit Mittagsschlaf", byHeavyMeal: "Nach schwerer Mahlzeit",
    byFasted: "Nüchtern", byAnxious: "Bei Nervosität",
    byCondition: "Nach körperlicher Verfassung", byPartner: "Nach Partner",
    gameDetail: {
      whenServing: "Bei eigenem Aufschlag", whenReturning: "Beim Return",
      held: "Gehalten", broken: "Gebreakt", opponentHeld: "Gegner hielt", iBroke: "Ich breakte",
      deuce: "Einstand", pressure: "Druck",
      serviceCoverage: "Details für {{detailed}} von {{total}} Aufschlagspielen erfasst",
      returnCoverage: "Details für {{detailed}} von {{total}} Returnspielen erfasst",
      smallSample: "Kleine Stichprobe · n={{count}}",
      noServiceData: "Noch keine detaillierten Aufschlagspiele", noReturnData: "Noch keine detaillierten Returnspiele",
      unlock: "Erfasse beim Loggen Spieldetails, um diese Verteilung zu sehen.",
      serviceTooltip: "{{percentage}} % · {{count}} von {{total}} detaillierten Aufschlagspielen",
      returnTooltip: "{{percentage}} % · {{count}} von {{total}} detaillierten Returnspielen",
      serviceHeld: { "0": "Gehalten bei 0 des Returnspielers", "15": "Gehalten bei 15 des Returnspielers", "30": "Gehalten bei 30 des Returnspielers", D: "Nach Einstand gehalten", DG: "Nach abgewehrtem Breakball gehalten" },
      serviceBroken: { "0": "Zu 0 gebreakt", "15": "Bei 15 gebreakt", "30": "Bei 30 gebreakt", D: "Nach Einstand gebreakt", DG: "Nach eigenem Spielball gebreakt" },
      returnHeld: { "0": "Gegner hielt bei 0 für mich", "15": "Gegner hielt bei 15 für mich", "30": "Gegner hielt bei 30 für mich", D: "Gegner hielt nach Einstand", DG: "Gegner hielt nach meinem Breakball" },
      returnBreak: { "0": "Zu 0 gebreakt", "15": "Bei 15 des Gegners gebreakt", "30": "Bei 30 des Gegners gebreakt", D: "Nach Einstand gebreakt", DG: "Nach Spielball des Gegners gebreakt" },
    },
  },
  theme: { label: "Design", court: "Court bei Nacht", clay: "Sand", daylight: "Tageslicht", grass: "Rasen", hardcourt: "Hartplatz" },
  insights: {
    pageSubtitle: "KI-gestützte Analyse deiner Matches.",
    pickOpponent: "Gegner",
    title: "Insights", subtitle: "Muster aus deinen Daten + KI-Coach.",
    askAi: "KI fragen", generating: "Erstelle…", aiNarrative: "KI-Analyse",
    notEnough: "Noch nicht genug Daten — weiter loggen.",
    aiError: "Insights konnten nicht erstellt werden.",
  },
  insightsPreview: {
    title: "Was Tennis Log entdecken wird",
    subtitle: "Logge deine Matches und Tennis Log erkennt nach und nach die Muster hinter deinen Ergebnissen.",
    learningTitle: "Was Tennis Log als Nächstes lernt",
    learningSubtitle: "Diese Bereiche brauchen etwas mehr Match-Historie, bevor sich dazu etwas sagen lässt.",
    examplesLabel: "Beispiele dafür, was Tennis Log entdecken kann",
    badge: "Beispiel",
    cta: "Erstes Match loggen",
    disclaimer: "Das sind beispielhafte Muster, keine Aussagen über dich. Sie beruhen nicht auf deinen Daten.",
    items: {
      serve: { text: "In engen Matches spielst du besser, wenn dein erster Aufschlag sitzt.", unlock: "Logge Aufschlag-Bewertungen in einigen Matches, um das freizuschalten." },
      opponents: { text: "Deine Ergebnisse gegen stärkere Gegner werden besser.", unlock: "Logge ein paar weitere Matches mit Gegnerniveau, um das freizuschalten." },
      pressure: { text: "Deine unerzwungenen Fehler steigen in Drucksätzen.", unlock: "Logge ein paar weitere Matches, um zu sehen, ob Druck deine Leistung beeinflusst." },
      surface: { text: "Auf einem Belag gewinnst du häufiger als auf einem anderen.", unlock: "Logge Matches auf verschiedenen Belägen, um das freizuschalten." },
    },
  },
  gaps: {
    title: "Was Tennis Log noch nicht weiß",
    subtitle: "Je vollständiger deine Match-Einträge, desto klüger wird dein persönlicher KI-Coach.",
    knowledgeTitle: "KI-Wissen",
    knowledgeHint: "Eine Schätzung, wie viele nützliche Informationen für sinnvolle KI-Analysen vorliegen.",
    loggedIn: "In {{pct}}% deiner Matches erfasst.",
    notYet: "Noch keine Daten vorhanden.",
    couldReveal: "Tennis Log könnte zeigen:",
    cta: "Jetzt mit erfassen",
    doneTitle: "Ausgezeichnet!",
    doneBody: "Tennis Log hat bereits genug Daten für hochwertige KI-Insights. Logge weiter Matches, um die Sicherheit zu erhöhen und neue Langzeitmuster zu entdecken.",
    items: {
      selfRatings: {
        label: "Deine eigenen Bewertungen",
        bullets: ["welche Schläge deine Matches wirklich entscheiden", "wie sich dein Niveau über die Sätze verändert", "deinen Fortschritt über die Saison"],
      },
      opponentRatings: {
        label: "Gegner-Bewertungen",
        bullets: ["Stärken, die gegen stärkere Gegner zählen", "Schwächen, die nur auf gleichem Niveau auftreten", "personalisierte Matchup-Analyse"],
      },
      sleep: {
        label: "Schlaf",
        bullets: ["ob Schlaf deine Siegquote beeinflusst", "deine Ausdauer", "deine Leistung im dritten Satz"],
      },
      nutrition: {
        label: "Ernährung",
        bullets: ["wie Mahlzeiten die Leistung beeinflussen", "ob schwere Mahlzeiten die Konstanz senken", "wie Fasten deine Ausdauer verändert"],
      },
      weather: {
        label: "Wetter & Bedingungen",
        bullets: ["wie Sonne, Wind oder Regen dein Spiel verändern", "Leistung unter Flutlicht", "dein optimaler Temperaturbereich"],
      },
      court: {
        label: "Platz & Bälle",
        bullets: ["deinen stärksten Belag", "wie der Ballzustand deinen Rhythmus beeinflusst", "welche Anlagen deinem Spiel liegen"],
      },
      emotions: {
        label: "Kopf & Energie",
        bullets: ["wie Nervosität enge Sätze beeinflusst", "die Wirkung eines anstrengenden Tages", "wann Ruhe Matches dreht"],
      },
      watch: {
        label: "Smartwatch",
        bullets: ["Ermüdungserkennung", "Erholungsmuster", "Zusammenhänge von Puls und Intensität"],
      },
    },
  },
  composite: {
    title: "Zusammengesetzte Insights",
    subtitle: "Muster, die erst sichtbar werden, wenn mehrere Signale kombiniert werden.",
    disclaimer: "Zusammengesetzte Insights beschreiben Korrelationen in deinen Daten, keine bewiesenen Ursachen. Sie erscheinen nur bei ausreichender Stichprobe und Effektgröße.",
    showMore: "{{count}} weitere anzeigen",
    showLess: "Weniger anzeigen",
    direction: {
      positive: "Positiver Befund",
      negative: "Negativer Befund",
      neutral: "Neutraler Befund",
    },
    cat: {
      momentum: "Momentum & Matchverlauf",
      context: "Leistung nach Bedingungen",
      opponent: "Gegner-Analyse",
      physical: "Körperliche Bereitschaft",
      development: "Entwicklung",
      matchup: "Matchup-Analyse",
    },
    ev: {
      groups: "Du hast {{aWins}} von {{aSample}} Matches ({{aRate}}%) {{aLabel}} gewonnen, gegenüber {{bWins}} von {{bSample}} ({{bRate}}%) {{bLabel}}.",
      single: "Du hast {{aWins}} von {{aSample}} Matches ({{aRate}}%) gewonnen.",
      ratingTrend: "Durchschnittliche Selbstbewertung {{recentAvg}} in deinen letzten {{recentN}} Matches, gegenüber {{prevAvg}} in den {{prevN}} davor.",
    },
    grp: {
      metricAbove: "wenn du dich in diesem Bereich über deinem Schnitt bewertet hast: {{skill}}",
      metricBelow: "wenn deine Bewertung auf oder unter deinem Schnitt lag",
      metricAboveSurface: "auf {{surface}}, wenn du dich in diesem Bereich über deinem Schnitt bewertet hast: {{skill}}",
      metricBelowSurface: "auf {{surface}}, wenn deine Bewertung auf oder unter deinem Schnitt lag",
      lostFirstSet: "nach verlorenem ersten Satz",
      wonFirstSet: "nach gewonnenem ersten Satz",
      long: "in Matches über 90 Minuten",
      short: "in Matches unter 90 Minuten",
      decider: "in Matches mit Entscheidungssatz",
      overall: "über alle erfassten Matches",
      tiebreak: "in Matches mit Tie-Break",
      surfaceOn: "auf diesem Belag: {{surface}}",
      surfaceOff: "auf anderen Belägen",
      morning: "in Vormittagsmatches",
      afternoon: "in Nachmittags- und Abendmatches",
      floodlit: "unter Flutlicht",
      daylight: "bei Tageslicht",
      skillBetter: "wenn du dich in diesem Bereich höher bewertet hast: {{skill}}",
      skillWorse: "wenn der Gegner dort höher bewertet war",
      goodSleepLong: "in langen Matches nach 7+ Stunden Schlaf",
      lowSleepLong: "in langen Matches nach weniger Schlaf",
      goodSleepDecider: "in Matches mit Entscheidungssatz nach 7+ Stunden Schlaf",
      lowSleepDecider: "in Matches mit Entscheidungssatz nach weniger Schlaf",
      heavyMeal: "nach einer schweren Mahlzeit",
      noHeavyMeal: "ohne schwere Mahlzeit",
      recentPeriod: "in deinen letzten {{n}} Matches",
      previousPeriod: "in den {{n}} Matches davor",
      h2hLostFirst: "gegen diesen Gegner nach verlorenem ersten Satz",
      h2hOverall: "gegen diesen Gegner insgesamt",
    },
    msg: {
      mentalPressureStrong: "In Drucksituationen entscheidet der Kopf: {{skill}} — {{wins}} von {{sample}} solchen Matches gewonnen ({{rate}}%), wenn du dich über deinem Schnitt bewertet hast, gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) sonst.",
      mentalPressureWeak: "In Drucksituationen kostet dich der Kopf Matches: {{skill}} — {{wins}} von {{sample}} gewonnen ({{rate}}%), wenn du dich über deinem Schnitt bewertet hast, gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) sonst.",
      serveTightStrong: "In engen Sätzen macht dein Aufschlag den Unterschied: {{skill}} — {{wins}} von {{sample}} gewonnen ({{rate}}%), wenn du dich über deinem Schnitt bewertet hast, gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) sonst.",
      serveTightWeak: "Enge Sätze legen eine Aufschlagschwäche offen: {{skill}} — {{wins}} von {{sample}} gewonnen ({{rate}}%), wenn du dich über deinem Schnitt bewertet hast, gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) sonst.",
      techniqueSurfaceStrong: "Auf {{surface}} entscheidet ein Bereich das Ergebnis: {{skill}} — {{wins}} von {{sample}} gewonnen ({{rate}}%), wenn du dich über deinem Schnitt bewertet hast, gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) sonst.",
      techniqueSurfaceWeak: "Auf {{surface}} bremst dich ein Bereich: {{skill}} — {{wins}} von {{sample}} gewonnen ({{rate}}%), wenn du dich über deinem Schnitt bewertet hast, gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) sonst.",
      comebackStrong: "Du drehst Matches nach verlorenem ersten Satz gut — {{wins}} von {{sample}} solchen Matches gewonnen ({{rate}}%).",
      comebackWeak: "Nach verlorenem ersten Satz tust du dich derzeit schwer — nur {{wins}} von {{sample}} solchen Matches gewonnen ({{rate}}%).",
      fadeLong: "In langen Matches lässt du nach — {{wins}} Siege in {{sample}} Matches über 90 Minuten ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) in kürzeren.",
      thriveLong: "Lange Matches liegen dir — {{wins}} Siege in {{sample}} Matches über 90 Minuten ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) in kürzeren.",
      deciderStrong: "Im Entscheidungssatz steigerst du dich — {{wins}} von {{sample}} solchen Matches gewonnen ({{rate}}%), über deinen {{baseline}}% insgesamt.",
      deciderWeak: "Entscheidungssätze kosten dich Matches — {{wins}} von {{sample}} solchen Matches gewonnen ({{rate}}%), unter deinen {{baseline}}% insgesamt.",
      tiebreakStrong: "Tie-Breaks laufen für dich — {{wins}} von {{sample}} Matches mit Tie-Break gewonnen ({{rate}}%), über deinen {{baseline}}% insgesamt.",
      tiebreakWeak: "Tie-Breaks kosten dich Matches — {{wins}} von {{sample}} Matches mit Tie-Break gewonnen ({{rate}}%), unter deinen {{baseline}}% insgesamt.",
      surfaceStrong: "Dieser Belag liegt dir: {{surface}} — {{wins}} Siege in {{sample}} Matches ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) anderswo.",
      surfaceWeak: "Dieser Belag fällt dir am schwersten: {{surface}} — {{wins}} Siege in {{sample}} Matches ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) anderswo.",
      morningBetter: "Vormittags erzielst du deine besten Ergebnisse — {{wins}} von {{sample}} ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) später am Tag.",
      eveningBetter: "Später am Tag spielst du besser — {{wins}} von {{sample}} ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) am Vormittag.",
      floodlightsBetter: "Unter Flutlicht hält dein Spiel besser — {{wins}} von {{sample}} ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) bei Tageslicht.",
      floodlightsWorse: "Flutlichtmatches fallen dir schwerer — {{wins}} von {{sample}} ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) bei Tageslicht.",
      strongOppSkill: "Gegen stärkere Gegner entscheidet ein Bereich: {{skill}} — {{wins}} von {{sample}} Matches gewonnen ({{rate}}%), wenn du dort höher bewertet warst.",
      strongOppWeak: "Gegen stärkere Gegner reicht ein Vorteil in einem Bereich nicht: {{skill}} — {{wins}} Siege in {{sample}} Matches ({{rate}}%).",
      peerOppSkill: "Gegen Gegner auf deinem Niveau bringt ein Bereich den Vorteil: {{skill}} — {{wins}} Siege in {{sample}} Matches ({{rate}}%).",
      sleepLongMatches: "In langen Matches zeigt sich der Schlaf — {{wins}} von {{sample}} Siegen nach 7+ Stunden Schlaf ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) mit weniger.",
      fatigueThirdSet: "In Matches mit Entscheidungssatz — {{wins}} von {{sample}} Siegen nach 7+ Stunden Schlaf ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) mit weniger.",
      mealStrongOpp: "Gegen stärkere Gegner zeigt sich eine schwere Mahlzeit — {{wins}} von {{sample}} Siegen ohne schwere Mahlzeit ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) mit.",
      skillRising: "Ein Bereich entwickelt sich nach oben: {{skill}} — rund +{{diff}} Bewertungspunkte in deinen letzten {{sample}} Matches.",
      skillFalling: "Ein Bereich entwickelt sich nach unten: {{skill}} — rund -{{diff}} Bewertungspunkte in deinen letzten {{sample}} Matches.",
      formUp: "Deine Form steigt — {{wins}} von deinen letzten {{sample}} Matches gewonnen ({{rate}}%), gegenüber {{otherWins}} von den {{otherSample}} davor ({{otherRate}}%), bei ähnlich starken Gegnern.",
      formDown: "Deine Form ist gefallen — {{wins}} von deinen letzten {{sample}} Matches gewonnen ({{rate}}%), gegenüber {{otherWins}} von den {{otherSample}} davor ({{otherRate}}%), bei ähnlich starken Gegnern.",
      matchupSkill: "Gegen {{opponent}} entscheidet ein Bereich: {{skill}} — {{wins}} von {{sample}} gewonnen ({{rate}}%), wenn du dort höher bewertet warst.",
      matchupFirstSet: "Gegen {{opponent}} drehst du einen verlorenen ersten Satz selten — {{wins}} von {{sample}} gewonnen ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) in allen Duellen.",
      matchupComeback: "Gegen {{opponent}} entscheidet ein verlorener erster Satz nichts — {{wins}} von {{sample}} gewonnen ({{rate}}%), gegenüber {{otherWins}} von {{otherSample}} ({{otherRate}}%) in allen Duellen.",
    },
  },
  coach: {
    driverTitle: "Entscheidender Faktor",
    driverLead: "Ein Bereich entscheidet die meisten deiner Matches – in beide Richtungen: {{topic}}.",
    driverSupport: "Bisher gezählt: {{goodWins}} Siege in {{goodSample}} Matches ({{goodRate}}%), wenn es lief, gegenüber {{badWins}} in {{badSample}} ({{badRate}}%), wenn nicht.",
    title: "KI-Coach-Zusammenfassung",
    subtitle: "Das Wichtigste, das Tennis Log aus deinen Matches gelernt hat.",
    notEnough: "Noch zu wenige Matches für Schlussfolgerungen — logge weiter.",
    strengthTitle: "Größte Stärke",
    weaknessTitle: "Größte Schwäche",
    possibleStrengthTitle: "Mögliche Stärke",
    possibleWeaknessTitle: "Mögliches Verbesserungsfeld",
    strengthLead: "Deine Daten zeigen deine größte Stärke hier: {{topic}}.",
    weaknessLead: "Deine Daten zeigen deine größte Schwäche hier: {{topic}}.",
    strengthLeadTentative: "Erste Anzeichen für eine Stärke hier: {{topic}} — die Datenbasis ist aber noch klein.",
    weaknessLeadTentative: "Erste Anzeichen für ein Verbesserungsfeld hier: {{topic}} — die Datenbasis ist aber noch klein.",
    focusTitle: "Fokus fürs nächste Match",
    focusOne: "Konzentriere dich im nächsten Match vor allem hierauf: {{first}}.",
    focusTwo: "Konzentriere dich im nächsten Match vor allem hierauf: {{first}} — und behalte als verlässliche Waffe: {{second}}.",
    disclaimer: "Das sind Muster aus deinen eigenen Daten, keine bewiesenen Ursachen.",
    confidence: {
      high: "Hohe Verlässlichkeit",
      medium: "Mittlere Verlässlichkeit",
      low: "Geringe Verlässlichkeit",
    },
  },
  watch: {
    uploadScreenshot: "Screenshot hochladen", uploading: "Lädt hoch...", aiExtracting: "KI extrahiert...",
    removeImage: "Bild entfernen", imageRequired: "Wähle ein Bild (PNG/JPG)",
    uploadFailed: "Upload fehlgeschlagen", extractFailed: "KI-Extraktion fehlgeschlagen",
    extracted: "Daten aus Screenshot extrahiert!",
    sourcesHint: "Aus Mi Fitness, Garmin, Apple Watch, Zepp etc. Felder werden automatisch ausgefüllt.",
    multipleHint: "Du kannst mehrere Screenshots hochladen.",
    screenshotAlt: "Smartwatch-Workout-Screenshot",
    kcal: "Kalorien (kcal)", duration: "Dauer (min)", avgBpm: "Ø BPM", maxBpm: "Max BPM",
    hrZones: "Herzfrequenzzonen", notes: "Uhr-Notizen", notesPlaceholder: "Trainingseffekt, Erholung, etc.",
  },
  surfaces: { hard: "Hart", clay: "Sand", grass: "Rasen", carpet: "Teppich" },
  ad: { label: "Werbung" },
  footer: {
    rights: "Alle Rechte vorbehalten.",
    contact: "Kontakt", contactTitle: "Tennis Ledger kontaktieren",
    contactHint: "Schick uns eine Nachricht.",
    yourEmail: "Deine E-Mail", subject: "Betreff", message: "Nachricht", send: "E-Mail öffnen",
  },
  install: {
    iosCta: "Auf dem iPhone installieren",
    platforms: "Verfügbar für Android · Läuft auf dem iPhone",
    iosSheetTitle: "Tennis Log wie eine App nutzen",
    iosSheetIntro: "Füge Tennis Log mit wenigen Tipps zum Home-Bildschirm hinzu – ohne App Store.",
    iosSheetStep1: "Öffne Tennis Log in Safari",
    iosSheetStep2: "Tippe auf „Teilen“",
    iosSheetStep3: "Tippe auf „Zum Home-Bildschirm“",
    iosSheetStep4: "Tippe auf „Hinzufügen“",
    iosReassurance: "Tennis Log erscheint auf deinem Home-Bildschirm und öffnet sich wie eine App.",
    iosNonSafari: "Um Tennis Log auf dem iPhone zu installieren, öffne diese Seite in Safari.",
    iosNonSafariHint: "Öffne das Browser-Menü, wähle „In Safari öffnen“ und dann Teilen → Zum Home-Bildschirm.",
    iosNudgeTitle: "Tennis Log immer griffbereit",
    iosNudgeBody: "Füge Tennis Log zum Home-Bildschirm hinzu – für ein App-Erlebnis.",
    iosNudgeShowMe: "Zeig mir wie",
    iosNudgeDismiss: "Jetzt nicht",
    cta: "App herunterladen",
    loading: "Die Installationsoption lädt, bitte warte ein paar Sekunden",
    opening: "Installationsdialog wird geöffnet…",
    unavailable: "Die Installationsoption ist gerade nicht verfügbar",
    title: "Tennis Log installieren",
    hint: "Füge Tennis Log zu deinem Gerät hinzu, um es wie eine echte App zu öffnen.",
    iosStep1: "Tippe auf Teilen",
    iosStep2: "Wähle anschließend „Zum Home-Bildschirm“.",
    iosStep3: "Tippe oben rechts auf „Hinzufügen“",
    androidStep1: "Tippe auf das Browser-Menü ⋮",
    androidStep2: "Wähle „App installieren“ oder „Zum Startbildschirm hinzufügen“.",
    androidStep3: "Bestätige die Installation",
    desktopHint: "In Chrome oder Edge auf dem Desktop:",
    desktopStep1: "Klicke auf das Installations-Symbol in der Adressleiste",
    desktopStep2: "Oder öffne das Browser-Menü und wähle „Tennis Log installieren“.",
  },

  profileSetup: {
    "title": "Spielerprofil vervollständigen",
    "subtitle": "Ein paar Angaben machen deine Statistiken und KI-Analysen deutlich genauer.",
    "dob": "Geburtsdatum",
    "level": "Dein Niveau (1–10)",
    "levelHint": "1 = du fängst gerade an, 10 = Wettkampfspieler auf hohem Niveau.",
    "unitsMetric": "Metrisch",
    "unitsUs": "US",
    "later": "Später",
    "saved": "Profil aktualisiert",
    "ctaTitle": "Spielerprofil vervollständigen",
    "ctaBody": "Dauert rund eine Minute und schärft jeden Vergleich in deinen Statistiken.",
    "ctaAction": "Profil vervollständigen",
    "countryPlaceholder": "Land auswählen",
    "countrySearch": "Land suchen…",
    "countryEmpty": "Kein Land gefunden"
  },
  settings: {
    healthConsent: "Einwilligung für Gesundheitsdaten",
    healthConsentActive: "Aktiv: Tennis Log darf die Gesundheitsdaten deiner Matches verarbeiten.",
    healthConsentInactive: "Nicht aktiv: Smartwatch- und Herzfrequenzdaten werden nicht verarbeitet.",
    healthConsentWithdraw: "Einwilligung widerrufen",
    healthConsentWithdrawn: "Einwilligung widerrufen und Gesundheitsdaten gelöscht.",
    healthConsentPartial: "Einwilligung widerrufen. Einige Gesundheitsdaten konnten noch nicht gelöscht werden – bitte in Kürze erneut versuchen.",
    healthConsentError: "Einwilligung konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    healthConsentWithdrawHint: "Widerrufen löscht deine gespeicherten Smartwatch-Screenshots und importierten Gesundheitsdaten (Herzfrequenz, Kalorien usw.) dauerhaft.",
    healthConsentWithdrawTitle: "Einwilligung für Gesundheitsdaten widerrufen?",
    healthConsentWithdrawBody: "Dies löscht dauerhaft deine gespeicherten Smartwatch-Screenshots und importierten Gesundheitsdaten, einschließlich Herzfrequenz und Kalorien, die mit deinen Matches gespeichert wurden. Dies lässt sich nicht rückgängig machen.",
    healthConsentWithdrawKeepMatches: "Deine Match-Einträge bleiben erhalten; es werden nur die gespeicherten Smartwatch- und Gesundheitsdaten entfernt.",
    healthConsentWithdrawConfirm: "Einwilligung widerrufen und Gesundheitsdaten löschen",
    title: "Einstellungen",
    profile: "Profil",
    displayName: "Anzeigename",
    age: "Alter",
    country: "Land",
    gender: "Geschlecht",
    gender_male: "Männlich", gender_female: "Weiblich", gender_other: "Andere", gender_prefer_not: "Keine Angabe",
    level: "Tennis-Niveau",
    level_beginner: "Anfänger", level_intermediate: "Mittel", level_advanced: "Fortgeschritten", level_competitive: "Wettkampf",
    profileSaved: "Profil gespeichert",
    password: "Passwort",
    newPassword: "Neues Passwort",
    changePassword: "Passwort ändern",
    pwdTooShort: "Passwort muss mind. 6 Zeichen haben",
    pwdChanged: "Passwort geändert",
    dataExport: "Datenexport",
    dataExportHint: "Lade alle {{count}} Matches als CSV herunter.",
    exportCsv: "Als CSV exportieren",
    noMatchesExport: "Keine Matches zum Exportieren.",
    exported: "{{count}} Matches exportiert",
    units: "Einheiten",
    unitsHint: "Wähle, wie Temperaturen und Gewichte angezeigt werden. Deine Daten werden immer in °C und kg gespeichert.",
    unitsMetric: "Metrisch (°C, kg)",
    unitsUs: "US (°F, lb)",
    cookiePrefs: "Cookie-Einstellungen",
    cookiePrefsHint: "Aktualisiere die erlaubten Cookie-Kategorien.",
    manageCookies: "Cookies verwalten",
    diagnostics: "App & Diagnose",
    diagnosticsHint: "Technische Details, die uns helfen, ein Problem nachzustellen. Es wird nichts Persönliches erfasst.",
    diagnosticsCopy: "Diagnose kopieren",
    diagnosticsCopied: "Diagnose in die Zwischenablage kopiert",
    diagnosticsCopyFailed: "Kopieren fehlgeschlagen — bitte erneut versuchen",
    reportProblem: "Problem melden",
    diagnosticsPasted: "Diagnose kopiert — fügen Sie sie in Ihre Nachricht ein.",
    diagLanguage: "Sprache",
    diagUnits: "Einheiten",
    diagDisplay: "Anzeigemodus",
    diagDisplayStandalone: "Installierte App (Standalone)",
    diagDisplayBrowser: "Browser-Tab",
    diagBrowser: "Browser",
    diagViewport: "Ansichtsfenster",
    diagOrientation: "Ausrichtung",
    diagHostname: "Hostname",
    dangerZone: "Gefahrenzone",
    deleteAccount: "Konto löschen",
    deleteHint: "Löscht dein Konto und alle Daten dauerhaft. Nicht rückgängig zu machen.",
    deleteConfirmTitle: "Konto löschen?",
    deleteConfirmDesc: "Alle Matches, Profildaten und Logins werden endgültig entfernt.",
    deleteForever: "Ja, löschen",
    accountDeleted: "Konto gelöscht",
    handedness: "Händigkeit", righty: "Rechtshänder", lefty: "Linkshänder", heightCm: "Größe ({{unit}})",
  },
  cookies: {
    title: "Deine Privatsphäre",
    intro: "Wir nutzen Cookies für die App-Funktion und optional zur Nutzungsmessung. Wähle, was du erlaubst.",
    necessary: "Unbedingt erforderlich",
    necessaryDesc: "Für Login und Kernfunktionen nötig. Immer aktiv.",
    analytics: "Analyse",
    analyticsDesc: "Anonyme Nutzungsstatistiken zur Verbesserung.",
    marketing: "Marketing",
    marketingDesc: "Für personalisierte Werbung.",
    acceptAll: "Alle akzeptieren",
    rejectAll: "Alle ablehnen",
    customize: "Anpassen",
    savePrefs: "Speichern",
  },
  invite: {
    title: "Freund einladen",
    subtitle: "Teile My Tennis Ledger — scanne den QR oder kopiere den Link.",
    copyLink: "Link kopieren",
    share: "Teilen",
    copied: "Link kopiert!",
    shareText: "Verfolge deine Tennis-Historie mit My Tennis Ledger:",
  },
  help: {
    eyebrow: "Hilfe-Center",
    title: "So funktioniert Tennis Log",
    subtitle: "Eine schnelle Tour durch alle Funktionen, mit Screenshots und Tipps. Klicke auf einen Abschnitt, um direkt dorthin zu springen.",
    tocTitle: "Auf dieser Seite",
    tocTroubleshooting: "Fehlerbehebung",
    tocWhoFor: "Für wen ist Tennis Log?",
    tocAbout: "Über Tennis Log",
    s1Title: "Erste Schritte",
    s1Body: "Erstelle ein Konto mit E-Mail oder Google. Du landest auf dem Dashboard — vorerst leer. Tippe auf „+ Neues Spiel“, um das erste zu erfassen.",
    s2Title: "Das Dashboard",
    s2Body: "Sechs Zusammenfassungen oben: Siegquote, Sätze, Spiele, Hold-Rate, gewonnene Breaks und Aktuelle Form. Jede spiegelt den aktuellen Filter wider (Jahr, Format, Art). Darunter: Siegquoten-Trend und letzte Matches.",
    s3Title: "Spiel hinzufügen",
    s3Body: "Beginne in New Match mit Gegner, Platz und Ergebnis, damit das Resultat nicht verloren geht. Nutze danach Score Timeline, Opponent, Context, Performance Review und Smartwatch, um nur den Detailgrad zu ergänzen, an den du dich tatsächlich erinnerst. Du kannst zuerst das Kernmatch speichern und später zum selben Eintrag zurückkehren.",
    s4Title: "Spielliste",
    s4Body: "Suche nach Gegner, filtere nach Format und Art, klicke auf eine Zeile zum Bearbeiten. Massenaktionen und CSV-Export in den Einstellungen.",
    s5Title: "Stats",
    s5Body: "Tiefe Auswertung: Direktduell, nach Platz, Belag, Temperatur, Jahr/Monat, Alter & Erfahrung des Gegners, Ballzustand, sogar nach Regen oder Flutlicht.",
    s6Title: "KI-Insights",
    s6Body: "Klicke auf „Ask AI“, um eine coachartige Auswertung auf Grundlage deines Matchverlaufs zu erhalten. Die KI-Analyse ist verfügbar, sobald du Matchdaten erfasst hast, und wird im Allgemeinen aussagekräftiger, wenn dein Verlauf wächst. Wenn du AI Insights anforderst, werden nur datenschutzgefilterte, ausdrücklich erlaubte Matchdaten gesendet; persönliche Kennungen werden gemäß der Datenschutzrichtlinie entfernt oder pseudonymisiert.",
    s7Title: "Smartwatch-Import",
    s7Body: "Auf der Seite „Neues Spiel“ scrolle zu „Smartwatch-Daten“, lade einen Screenshot deiner Watch-App hoch und wir füllen kcal, Dauer, ø/max BPM und HF-Zonen automatisch per KI aus.",
    s8Title: "Export & Löschen",
    s8Body: "In den Einstellungen kannst du dein Passwort ändern, Cookies verwalten, alles als CSV exportieren oder dein Konto endgültig löschen.",
    ctaTitle: "Bereit loszulegen?",
    ctaDesc: "Schnell und einfach — du siehst deine ersten Stats nach einem Spiel.",
    ctaBtn: "Konto erstellen",
    troubleshootingTitle: "Fehlerbehebung",
    troubleshootingItems: [
      { q: "Ich kann mich nicht anmelden", a: "Stelle sicher, dass du denselben Anbieter verwendest, mit dem du dich registriert hast (E-Mail oder Google). Wenn du dein Passwort vergessen hast, nutze den Reset-Link auf dem Anmeldebildschirm. Immer noch Probleme? Nutze den Kontakt-Link im Footer mit deiner verwendeten E-Mail." },
      { q: "Mein Match wurde nicht gespeichert", a: "Zum Speichern eines Matches sind ein Gegner und ein Platz erforderlich. Ergebnisse und weitere Details können nach und nach ergänzt werden. Eine rote Fehlermeldung zeigt, welches Feld fehlt. Netzwerkprobleme können das Speichern ebenfalls blockieren — versuche es mit einer stabilen Verbindung erneut." },
      { q: "AI Insights werden nicht erstellt", a: "AI Insights brauchen mindestens einige erfasste Matches, um Muster zu finden. Wenn du genug Daten hast, aber trotzdem einen Fehler siehst, ist der KI-Dienst möglicherweise vorübergehend limitiert — warte eine Minute und versuche es erneut." },
      { q: "Smartwatch-Screenshot wird nicht analysiert", a: "Der Parser funktioniert am besten mit klaren, kontrastreichen Screenshots von Apple Watch, Garmin, Polar oder Fitbit. Schneide eng um die Workout-Zusammenfassung und stelle sicher, dass Herzfrequenz und Dauer lesbar sind." },
      { q: "Statistik-Zahlen sehen falsch aus", a: "Die meisten Stat-Überraschungen kommen von fehlender Aufschlagreihenfolge in game-by-game-Matches — ohne sie kann die App Holds und Breaks nicht berechnen. Bearbeite das Match und prüfe, wer in jedem Satz zuerst aufgeschlagen hat." },
    ],
    whoTitle: "Für wen ist Tennis Log?",
    whoIntro: "Tennis Log ist für jeden Spieler gemacht, der sein Tennis etwas ernster nehmen möchte, als sich nur den Spielstand auf dem Heimweg zu merken. Es funktioniert gleich gut, egal ob du seit drei Monaten oder drei Jahrzehnten spielst — die Tiefe des Tools skaliert mit der Tiefe deines Match-Logs.",
    whoBeginnersTitle: "Anfänger",
    whoBeginnersBody: "Wenn du gerade erst angefangen hast, ist das Nützlichste, was Tennis Log dir gibt, eine einfache, strukturierte Aufzeichnung deiner ersten Matches. Du musst noch keine Holds und Breaks erfassen. Erfasse einfach Gegner, Spielstand, Belag und eine kurze Notiz. Nach 10-15 Matches hast du eine Basis, auf die du sechs Monate später zurückblicken und sagen kannst: „Ich bin klar besser geworden“ — mit Beweisen statt Gefühlen.",
    whoIntermediateTitle: "Fortgeschrittene Spieler",
    whoIntermediateBody: "Für Vereins- und Ligaspieler ist Tennis Log besonders nützlich. Game-by-game-Tracking liefert echte Hold- und Break-Prozente. Die KI-Analyse ist verfügbar, sobald du Matchdaten erfasst hast, und wird im Allgemeinen aussagekräftiger, wenn dein Verlauf wächst. Belag- und Gegnerfilter helfen dir, Unterschiede zu untersuchen, und ein strukturiertes Match-Log kann klarere Fragen für das Training oder eine Einheit mit deinem Coach liefern.",
    whoCompetitiveTitle: "Wettkampfspieler",
    whoCompetitiveBody: "Wenn du Turniere oder eine ernsthafte Liga spielst, funktioniert Tennis Log als persönliche Performance-Datenbank. Erfasse Bedingungen, Schlaghand des Gegners, Bewertungen beider Seiten, Smartwatch-Daten, mentale Notizen — und teile die Stats nach Jahr, Belag, Art (Freundschaft vs. offiziell), Partner und mehr. Exportiere jederzeit als CSV und nimm die Daten in die Trainersitzung mit.",
  },
  landing: {
    heroEyebrow: "Das smarte Tennis-Tagebuch",
    heroTitle: "Schluss mit Raten. Studiere dein Tennis.",
    heroDesc: "Tennis Log ist ein elegantes Tagebuch für Hobby- und Wettkampfspieler. Trage jedes Match ein, sieh tiefe Statistiken und lass die KI Muster finden, die dich ausbremsen.",
    featuresTitle: "Alles, was du brauchst, nichts Überflüssiges",
    f1Title: "Jedes Match in Sekunden eintragen",
    f1Desc: "Score pro Satz, Gegner, Platz, Belag, Wetter, sogar deine Doppelfehler — schnelle Drop-downs machen es mühelos.",
    f2Title: "Statistiken, die wirklich zählen",
    f2Desc: "Siegquote, Aufschlagspielquote, Breakquote, Sätze, Spiele, Performance pro Belag, Platz und Gegner.",
    f3Title: "KI-Insights",
    f3Desc: "Erhalte eine Coach-Analyse — Stärken, Schwächen und Muster aus deinem gesamten Verlauf.",
    f4Title: "Smartwatch-Import",
    f4Desc: "Lade einen Screenshot von Mi Fitness, Garmin, Apple Watch oder Zepp hoch — KI füllt Kalorien, BPM und HF-Zonen aus.",
    f5Title: "Spiel-für-Spiel-Tracking",
    f5Desc: "Du willst tief eintauchen? Erfasse Punkt-für-Punkt-Sequenzen und entdecke deine Erfolgsquote pro Spiel.",
    f6Title: "7 Sprachen",
    f6Desc: "EN · EL · ES · FR · DE · IT · JA — dein Tennis-Verlauf in deiner Sprache.",
    previewTitle: "Ein Blick hinein",
    shotDashLabel: "Dashboard", shotDashTitle: "Deine Saison auf einen Blick",
    shotDashDesc: "Sechs Zusammenfassungen erzählen die Geschichte: Siegquote, Sätze, Spiele, Hold-Rate, gewonnene Breaks und Aktuelle Form. Jede spiegelt die ausgewählten Filter wider.",
    shotAddLabel: "Match hinzufügen", shotAddTitle: "Ein Match in unter einer Minute eintragen",
    shotAddDesc: "Beginne mit Fast Track, um das Wesentliche zu speichern, und ergänze anschließend nach Wunsch Details über Score Timeline, Opponent, Context, Performance Review und Smartwatch.",
    shotStatsLabel: "Statistiken", shotStatsTitle: "Tiefer Einblick in die Zahlen",
    shotStatsDesc: "Einzel vs Doppel, freundschaftlich vs offiziell, Aufschlagspielquote, Breakquote, Returnspiele — jede Statistik so, wie du sie willst.",
    shotTrendLabel: "Sieg-Trend", shotTrendTitle: "Sieh deine Form sich entwickeln",
    shotTrendDesc: "Filtere nach Einzel, Doppel, freundschaftlich oder offiziell — und beobachte deine rollende Siegquote Match für Match.",
    shotPerfLabel: "Leistung", shotPerfTitle: "Bewerte dich und deinen Gegner",
    shotPerfDesc: "Bewerte Vorhand, Rückhand, Aufschlag, Return, Volley, Stoppball, Lob, Ausdauer, Schnelligkeit und Taktik — für beide Seiten — und sieh sie im Radar-Chart.",
    shotPerGameLabel: "Erfolg pro Spiel", shotPerGameTitle: "Finde dein schwaches Spiel",
    shotPerGameDesc: "Entdecke, ob du in Spiel 3 patzt oder Spiel 11 abschließt — aufgeschlüsselt nach Aufschlagseite und Satz.",
    shotWatchLabel: "Smartwatch", shotWatchTitle: "Herz, Kalorien, Zonen — automatisch",
    shotWatchDesc: "Lade einen Screenshot deiner Watch-App hoch und KI füllt Kalorien, Dauer, Durchschnitts-BPM, Max-BPM und HF-Zonen aus.",
    howTitle: "So funktioniert's",
    s1Title: "Match hinzufügen", s1Desc: "Tippe „+ Neues Match“, trage Score, Gegner und Bedingungen ein. Unter einer Minute.",
    s2Title: "Sieh deine Stats wachsen", s2Desc: "Dein Dashboard aktualisiert sich sofort. Filtere nach Jahr, Format, Art — wie du willst.",
    s3Title: "Frag den KI-Coach", s3Desc: "Nach ~10 Matches erkennt KI-Insights Muster: wo du patzt, wo du glänzt.",
    s4Title: "Verbessere dich, Match für Match", s4Desc: "Erkenne, was funktioniert, und verdopple es. Exportiere jederzeit als CSV.",
    trust1Title: "Privat & sicher", trust1Desc: "Deine Daten gehören dir. Verschlüsselt, niemals verkauft.",
    trust2Title: "Für Spieler gemacht", trust2Desc: "Von Tennisspielern, für Tennisspieler.",
    trust3Title: "Deins, in 7 Sprachen", trust3Desc: "EN · EL · ES · FR · DE · IT · JA.",
    faqTitle: "Häufige Fragen",
    faq1Q: "Was kostet Tennis Log?", faq1A: "Heute sind alle Funktionen kostenlos verfügbar — finanziert durch kleine Werbung. Wir führen eventuell zukünftig optionale Bezahlpläne für erweiterte Funktionen ein.",
    faq2Q: "Muss ich jeden Punkt erfassen?", faq2A: "Überhaupt nicht. Der schnellste Eintrag ist Datum + Gegner + Satzergebnisse. Detail-Tracking ist optional.",
    faq3Q: "Wie funktioniert der Smartwatch-Import?", faq3A: "Mache einen Screenshot deiner Workout-Zusammenfassung in einer Watch-App, lade ihn hoch und unsere KI extrahiert Kalorien, Dauer, Durchschnitts- und Max-BPM sowie HF-Zonen.",
    faq4Q: "Kann ich meine Daten exportieren?", faq4A: "Ja — exportiere alles jederzeit als CSV in den Einstellungen.",
  },
}

data.insightsH = {
  "overall": "Gesamtsiegquote",
  "overallDetail": "{{rate}}% bei {{sample}} entschiedenen Spielen.",
  "better": "Stärker im {{skill}} als der Gegner",
  "betterDetail": "Wenn Sie besser im {{skill}} sind, gewinnen Sie {{rate}}% ({{sample}} Spiele). Basis: {{baseline}}%.",
  "worse": "Schwächer im {{skill}} als der Gegner",
  "worseDetail": "Wenn Sie schwächer im {{skill}} sind, gewinnen Sie {{rate}}% ({{sample}} Spiele).",
  "condDetail": "{{rate}}% bei {{sample}} Spielen (Basis {{baseline}}%).",
  "cond": {
    "oneHanded": "Vs einhändige Rückhand",
    "twoHanded": "Vs beidhändige Rückhand",
    "lowSleep": "Wenig Schlaf (<6h)",
    "goodSleep": "Guter Schlaf (≥7h)",
    "tiring": "Anstrengender Tag",
    "floodlights": "Unter Flutlicht",
    "rainy": "Regenwetter",
    "napped": "Mittagsschlaf",
    "heavyMeal": "Schwere Mahlzeit",
    "fasted": "Nüchtern",
    "anxious": "Ängstlich",
    "newBalls": "Neue Bälle",
    "official": "Offizielle Spiele",
    "friendly": "Freundschaftsspiele",
    "singles": "Einzel",
    "doubles": "Doppel",
    "surface": "Belag: {{surface}}"
  },
  "skill": {
    "shot_accuracy": "Schlaggenauigkeit",
    "call_accuracy": "Genauigkeit der Aus-Entscheidungen",
    "confrontational_tendency": "Gelassenheit gegenüber dem Gegner",
    "forehand": "Vorhand",
    "backhand": "Rückhand",
    "service": "Aufschlag",
    "return": "Return",
    "volley": "Volley",
    "drop_shot": "Stoppball",
    "lob": "Lob",
    "stamina": "Ausdauer",
    "speed": "Schnelligkeit",
    "unforced_errors": "Fehlerkontrolle",
    "winners": "Winner",
    "tactics": "Taktik",
    "awareness": "Spielübersicht",
    "shot_variety": "Schlagvielfalt",
    "court_coverage": "Platzabdeckung",
    "fh_topspin": "Vorhand-Topspin",
    "fh_slice": "Vorhand-Slice",
    "bh_topspin": "Rückhand-Topspin",
    "bh_slice": "Rückhand-Slice",
    "first_serve": "erster Aufschlag",
    "first_serve_pct": "Quote erster Aufschlag",
    "first_serve_speed": "Tempo erster Aufschlag",
    "second_serve": "zweiter Aufschlag",
    "second_serve_pct": "Quote zweiter Aufschlag",
    "second_serve_speed": "Tempo zweiter Aufschlag",
    "serve_flat": "flacher Aufschlag",
    "serve_kick": "Kick-Aufschlag",
    "serve_slice": "Slice-Aufschlag",
    "smash": "Schmetterball",
    "passing_shots": "Passierschläge",
    "composure": "Nervenstärke",
    "concentration": "Konzentration",
    "calmness": "Ruhe",
    "anxiety": "Umgang mit Nervosität",
    "confidence": "Selbstvertrauen",
    "fighting_spirit": "Kampfgeist",
    "mental_resilience": "mentale Widerstandskraft",
    "belief_pre": "Zuversicht vor dem Match",
    "belief_in": "Zuversicht während des Matches"
  }
};
data.days = ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"];

data.quicklog = {
  "learnedAccordion": "Sieh, was Tennis Log bisher gelernt hat",
  "savedIndicator": "Gespeichert",
  "fastTrackEyebrow": "Schnellerfassung",
  "fastTrackTagline": "Erfasse ein Match in unter 30 Sekunden.",
  "revealMore": "Willst du reichere Antworten? Weiter unten mehr entdecken ↓",
  "bonus": "Bonus",
  "continue": "Weiter",
  "meterTitle": "Jetzt kann Tennis Log berechnen:",
  "meterSubtitle": "Diese Auswertungen sind heute schon verfügbar, basierend auf deinen erfassten Matches.",
  "meterMoreTitle": "Enthülle mehr, um zu beantworten",
  "meterInfoAria": "Über diese Auswertungen",
  "editScore": "Ergebnis bearbeiten",
  "timelineNoScore": "Noch kein Ergebnis eingegeben",
  "answers": {
    "winRate": "Gesamt-Siegquote",
    "history": "Match-Historie",
    "gamesPct": "% gewonnener Spiele",
    "setsPct": "% gewonnener Sätze",
    "monthly": "Siegquote pro Monat",
    "dayOfWeek": "Siegquote nach Wochentag",
    "headToHead": "Direktvergleich gegen diesen Gegner"
  },
  "future": {
    "opponent": "Welche Gegnerprofile deinem Spiel liegen",
    "timeline": "Wie sich deine Matches wirklich entwickeln",
    "context": "Welche Bedingungen dich am besten spielen lassen",
    "review": "Welche eigenen Fähigkeiten dir Matches gewinnen",
    "watch": "Was deine Smartwatch über deine Anstrengung sagt"
  },
  "stepTitles": {
    "fastTrack": "Schnellerfassung",
    "opponent": "Gegner",
    "timeline": "Spielverlauf",
    "context": "Kontext & Bedingungen",
    "review": "Bewerte deine Leistung",
    "watch": "Smartwatch"
  },
  "stepIntros": {
    "opponent": "Füge Gegner-Details hinzu, damit Tennis Log ein reicheres Bild deiner Gegner aufbauen kann. So werden tiefere Auswertungen möglich.",
    "timeline": "Erfasse den Verlauf jedes Satzes. So werden tiefere Auswertungen deiner Match-Muster möglich.",
    "context": "Erfasse die Bedingungen des Matches. So werden tiefere Kontext-Auswertungen möglich.",
    "review": "Bewerte deine eigene Leistung. So werden tiefere Auswertungen deiner Fähigkeiten möglich.",
    "watch": "Smartwatch dabei? Lade einen Screenshot hoch, die KI füllt alles automatisch aus."
  },
  "stepUnlocksLabel": "Du fütterst damit die Auswertung für:",
  "unlocks": {
    "opponent": [
      "Ergebnisse gegen Linkshänder",
      "Ergebnisse gegen erfahrene Spieler",
      "Ergebnisse nach Gegner-Spielstil",
      "Ergebnisse gegen einhändige Rückhand"
    ],
    "timeline": [
      "Wie du deine Sätze gewinnst und verlierst",
      "Break- und Hold-Muster",
      "Aufschlag-Konstanz über die Sätze"
    ],
    "context": [
      "Wie Bedingungen dein Spiel beeinflussen",
      "Ob Schlaf oder Erholung Ergebnisse verändern",
      "Wie Wetter mit deiner Leistung zusammenhängt"
    ],
    "review": [
      "Welche Fähigkeiten mit deinen Siegen korrelieren",
      "Welche Schwächen dich Matches kosten",
      "Wie sich deine Bewertungen im Zeitverlauf entwickeln"
    ],
    "watch": [
      "Kalorien und Dauer",
      "Durchschnittlicher und maximaler Puls",
      "Trainingslast und Erholung"
    ]
  },
  "successTitle": "Match gespeichert.",
  "successBody": "Tennis Log kann diese Fragen zu deinem Tennis bereits beantworten:",
  "successCtaMatches": "Meine Matches ansehen",
  "successCtaContinue": "Mehr Matchdetails hinzufügen — optional",

  "addMoreDetails": "Mehr Details hinzufügen",
  "finish": "Fertig & speichern",
  "wantRicher": "Möchtest du reichhaltigere Antworten?",
  "prev": "Zurück",
  "stepOf": "Schritt {{current}} von {{total}}",
  "dontShowRewards": "Nicht mehr anzeigen",
  "canLabel": "Tennis Log kann bereits erkennen:",
  "learnedLabel": {
    "match": "Was Tennis Log aus diesem Match gelernt hat:",
    "matches": "Was Tennis Log aus deinen Matches gelernt hat:",
    "tennis": "Was Tennis Log über dein Tennis weiß:"
  },
  "hintLabel": "Hast du noch eine Minute?",
  "rewardTitles": {
    "fastTrack": "Match gespeichert!",
    "timeline": "Ausgezeichnet!",
    "opponent": "Super!",
    "context": "Gut gemacht!",
    "review": "Fantastisch!"
  },
  "rewardBodies": {
    "fastTrack": "Dein Match gehört jetzt zu deiner Tennis-Historie.",
    "timeline": "Tennis Log versteht jetzt viel mehr davon, wie sich deine Matches entwickeln.",
    "opponent": "Tennis Log weiß jetzt viel mehr über die Spieler, gegen die du antrittst.",
    "context": "Tennis Log kann deine Leistung nun mit den Bedingungen verknüpfen, unter denen du gespielt hast.",
    "review": "Deine Leistungsbewertung liefert Tennis Log eine reichhaltige Quelle für Langzeit-Insights."
  },
  "rewardHints": {
    "fastTrack": "Erledige den nächsten Schritt und Tennis Log beginnt zu entdecken:",
    "timeline": "Als Nächstes hilfst du Tennis Log, deine Gegner zu verstehen.",
    "opponent": "Als Nächstes erfasst du die Match-Bedingungen.",
    "context": "✨ Hast du noch eine Minute? Dann bewerten wir jetzt die Leistung beider Spieler.",
    "review": "Ein letzter optionaler Schritt: verbinde deine Smartwatch."
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "Geschlecht des Gegners *",
  "genderMale": "Männlich",
  "genderFemale": "Weiblich",
  "genderOther": "Divers",
  "oppLevel": "Gesamtniveau des Gegners",
  "oppLevel1": "Kompletter Anfänger",
  "oppLevel5": "Durchschnittlicher Clubspieler",
  "oppLevel10": "Bester Gegner bisher",
  "oppLevelHint": "7 = starker Clubspieler · 9 = Turnierniveau",
  "oppBirthYear": "Geburtsjahr",
  "oppBirthMonth": "Monat",
  "oppBirthDay": "Tag",
  "oppTennisSince": "Spielt Tennis seit (Jahr)",
  "oppTennisSinceCompact": "Spielt seit",
  "oppLegacyValue": "früher gespeichert",
  "oppBirthInvalid": "Gib ein vollständiges vierstelliges Geburtsjahr an (ab 1900).",
  "oppAgePrev": "Früher erfasstes Alter",
  "oppExperiencePrev": "Früher erfasste Jahre Erfahrung",
  "oppSinceBeforeBirth": "Das Tennis-Startjahr kann nicht vor dem Geburtsjahr liegen.",
  "oppSinceFuture": "Das Tennis-Startjahr kann nicht in der Zukunft liegen.",
  "oppSinceRange": "Gib ein vollständiges vierstelliges Jahr an (ab 1900).",
  "oppStyleScore": "Defensiv ↔ offensiv",
  "oppStyleLegacy": "Früher erfasst als: {{value}}",
  "oppLevelAvg": "Durchschnitt früherer Matches: {{value}} ({{n}})",
  "oppLevelHistory": "Niveau-Verlauf",
  "oppAttackTags": "Womit er mir wehgetan hat",
  "oppErrorTags": "Wo er Fehler macht",
  "oppTagRemembered": "In einem früheren Match notiert",
  "attackGroup_serve": "Aufschlag & erster Schlag",
  "attackGroup_shape": "Schlagart",
  "attackGroup_target": "Zielrichtung",
  "errorGroup_technical": "Technisch",
  "errorGroup_situational": "Situativ",
  "attackTag_big_first_serve": "Starker erster Aufschlag",
  "attackTag_aggressive_return": "Aggressiver Return",
  "attackTag_serve_volley": "Serve-and-Volley",
  "attackTag_takes_ball_early": "Nimmt den Ball früh",
  "attackTag_heavy_topspin": "Schwerer Topspin",
  "attackTag_frequent_slice": "Häufiger Slice",
  "attackTag_drop_shots": "Stoppbälle",
  "attackTag_short_angles": "Kurze Winkel",
  "attackTag_effective_lobs": "Effektive Lobs",
  "attackTag_attacks_my_backhand": "Greift meine Rückhand an",
  "attackTag_attacks_my_forehand": "Greift meine Vorhand an",
  "attackTag_net_rusher": "Geht ans Netz",
  "attackTag_open_court": "Öffnet das Feld",
  "attackTag_changes_direction": "Wechselt die Richtung",
  "errorTag_backhand_breaks_down": "Rückhand bricht ein",
  "errorTag_forehand_breaks_down": "Vorhand bricht ein",
  "errorTag_high_balls": "Probleme mit hohen Bällen",
  "errorTag_low_balls": "Probleme mit tiefen Bällen",
  "errorTag_vs_heavy_topspin": "Probleme gegen schweren Topspin",
  "errorTag_vs_slice": "Probleme gegen Slice",
  "errorTag_vs_drop_shots": "Probleme gegen Stoppbälle",
  "errorTag_volley_errors": "Volleyfehler",
  "errorTag_return_errors": "Returnfehler",
  "errorTag_second_serve_errors": "Schwacher zweiter Aufschlag",
  "errorTag_errors_when_rushed": "Fehler unter Zeitdruck",
  "errorTag_errors_on_the_run": "Fehler im Laufen",
  "errorTag_overhits": "Schlägt zu hart",
  "errorTag_long_rallies": "Fehler in langen Ballwechseln",
  "errorTag_under_pressure": "Fehler unter Druck",
  "oppLevelEmpty": "Schiebe den Regler, um das Gesamtniveau des Gegners zu bewerten.",
  "oppLevelDesc_10": "Absoluter Anfänger",
  "oppLevelDesc_15": "Fängt gerade an zu lernen",
  "oppLevelDesc_20": "Anfänger mit wenig Matcherfahrung",
  "oppLevelDesc_25": "Entwickelt Grundkonstanz",
  "oppLevelDesc_30": "Gelegenheitsspieler",
  "oppLevelDesc_35": "Freizeitspieler mit Fortschritt",
  "oppLevelDesc_40": "Regelmäßiger Freizeitspieler",
  "oppLevelDesc_45": "Solider Freizeitspieler",
  "oppLevelDesc_50": "Durchschnittlicher Clubspieler",
  "oppLevelDesc_55": "Wettkampforientierter Clubspieler",
  "oppLevelDesc_60": "Starker Clubspieler",
  "oppLevelDesc_65": "Sehr starker Clubspieler",
  "oppLevelDesc_70": "Fortgeschrittener Clubspieler",
  "oppLevelDesc_75": "Starker Spieler bei lokalen Turnieren",
  "oppLevelDesc_80": "Turnierspieler auf hohem Niveau",
  "oppLevelDesc_85": "Sehr starker Turnierspieler",
  "oppLevelDesc_90": "Elite-Amateur / Regionalniveau",
  "oppLevelDesc_95": "Außergewöhnlicher Spieler",
  "oppLevelDesc_100": "Der beste Spieler, gegen den ich gespielt habe",
  "oppAttackNotes": "Wie greift dieser Gegner an?",
  "oppAttackNotesPlaceholder": "z. B. starker Aufschlag, nimmt den Ball früh…",
  "oppErrorNotes": "Wie macht dieser Gegner Fehler?",
  "oppErrorNotesPlaceholder": "z. B. Probleme, wenn die Rückhand unter Druck kommt…"
});
data.quicklog.stepTitles.review = "Spielerbewertung";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "Nur das Wichtigste — etwa 30 Sekunden.",
  "timeline": "Wie verlief das Match?",
  "opponent": "Erzähl uns kurz etwas über deinen Gegner.",
  "context": "Die Details machen den Unterschied.",
  "review": "Bewerte die Leistung beider Spieler — mit der Zeit erkennt Tennis Log, was deine Siege ausmacht.",
  "watch": "Hast du eine Smartwatch? Lass Tennis Log den Rest ausfüllen."
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "Perfekt!",
  "timeline": "Ausgezeichnet!",
  "opponent": "Wunderbar!",
  "context": "Klasse!",
  "review": "Großartige Arbeit!",
  "watch": "Alles erledigt!"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "Dein Match ist jetzt Teil deiner persönlichen Tennisgeschichte.",
  "timeline": "Tennis Log versteht jetzt viel besser, wie deine Matches verlaufen.",
  "opponent": "Tennis Log weiß jetzt viel mehr über deine Gegner.",
  "context": "Deine persönliche Datenbank ist noch klüger geworden — Tennis Log verbindet nun Leistung und Bedingungen.",
  "review": "Dein Spielerprofil ist viel reicher geworden — das deines Gegners auch. Tennis Log kann nun entdecken, welche Fähigkeiten dich gewinnen lassen.",
  "watch": "Du hast gerade einen der vollständigsten Matcheinträge deiner Tennisreise erstellt. Danke, dass du Tennis Log hilfst, dein Tennis zu verstehen."
});

data.guest = {
  "tryNow": "Jetzt ausprobieren — ohne Konto",
  "tryNowLine1": "Jetzt ausprobieren",
  "tryNowLine2": "Ohne Konto",
  "badge": "Gast-Sitzung",
  "sumScore": "Ergebnis",
  "sumType": "Spieltyp",
  "saveTitle": "Dein erstes Match ist fertig.",
  "saveSubtitle": "Du hast dein erstes Match bereits erfasst. Erstelle ein kostenloses Konto, um es dauerhaft zu speichern und deine Tennis-Historie zu starten.",
  "canTitle": "Tennis Log kann bereits berechnen",
  "beginningTitle": "Das ist erst der Anfang.",
  "beginningBody": "Mach weiter und Tennis Log lernt aus jedem Match viel mehr über dein Spiel.",
  "google": "Mit Google fortfahren",
  "createAccount": "Konto erstellen",
  "haveAccount": "Ich habe bereits ein Konto",
  "editAgain": "Match bearbeiten",
  "whyLink": "Warum brauche ich ein Konto?",
  "whyBody": "Deine Matches gehören dir. Ein Konto ermöglicht Tennis Log:",
  "whyB1": "deine Historie zu speichern",
  "whyB2": "über Geräte hinweg zu synchronisieren",
  "whyB3": "Langzeitstatistiken aufzubauen",
  "whyB4": "KI-Insights zu erstellen",
  "persisting": "Dein Match wird gespeichert…",
  "successTitle": "Perfekt!",
  "successBody": "Dein erstes Match ist jetzt Teil deiner Tennis-Historie.",
  "successContinue": "Mehr Matchdetails hinzufügen — optional"
};

data.appWelcome = {
  "heading": "Willkommen bei Tennis Log",
  "subheading": "Deine Tennisgeschichte beginnt mit deinem nächsten Match.",
  "googleCta": "Weiter mit Google",
  "googleHelper": "Schnell, sicher und ohne neues Passwort.",
  "guestCta": "Ohne Konto starten",
  "guestHelper": "Erfasse jetzt dein erstes Match. Deine Daten kannst du später mit Google sichern.",
  "haveAccount": "Du hast schon ein Konto? Anmelden",
  "carouselTitle": "Was verraten 25 Matches?",
  "carouselSubtitle": "Je mehr du erfasst, desto klarer wird dein Spiel.",
  "carouselTitle2": "Dein Tennis Log wächst mit jedem Match",
  "carouselSubtitle2": "Wische, um zu sehen, was aus deinen Statistiken werden kann.",
  "card4": "Jede Einheit, Kalorien und Herzfrequenz",
  "card5": "Deine Matches im Kalender",
  "card1": "Deine Saison auf einen Blick",
  "card2": "Sieh, wie sich dein Spiel entwickelt",
  "card3": "Entdecke Muster, die du allein nicht siehst",
  "footer": "Kernfunktionen kostenlos • Deine Daten bleiben deine • Für Clubspieler gemacht",
  "prev": "Zurück",
  "next": "Weiter",
  "mini": {
    "winRate": "Siegquote",
    "matches": "Matches",
    "sets": "Gewonnene Sätze",
    "trend": "Verlauf der Siegquote",
    "you": "Du",
    "opponent": "Gegner",
    "serve": "Aufschlag",
    "forehand": "Vorhand",
    "backhand": "Rückhand",
    "movement": "Bewegung",
    "strength": "Stärke",
    "strengthBody": "Du gewinnst 78% der Matches, wenn dir das erste Break gelingt.",
    "opportunity": "Potenzial",
    "opportunityBody": "Deine Rückhand-Bewertung fällt im dritten Satz — ein Fitness- oder Fokusmuster."
  }
};

data.consent = { health: { title: "Gesundheitsdaten — ausdrückliche Einwilligung", body: "Herzfrequenz, Herzfrequenzzonen, Kalorien, Trainingsdauer und Smartwatch-Screenshots sind Gesundheitsdaten. Tennis Log verarbeitet sie nur mit deiner ausdrücklichen Einwilligung, einschließlich der Übermittlung an einen KI-Anbieter für deine Auswertungen. Das ist freiwillig und jederzeit in den Einstellungen widerrufbar; dabei werden die gespeicherten Gesundheitsdaten gelöscht.", checkbox: "Ich willige ausdrücklich in die beschriebene Verarbeitung meiner Gesundheitsdaten durch Tennis Log ein.", enable: "Gesundheitsdaten aktivieren", optional: "Optional – Tennis Log funktioniert auch ohne vollständig.", granted: "Gesundheitsdaten aktiviert.", stale: "Der Einwilligungstext wurde aktualisiert. Bitte Seite neu laden und erneut lesen.", error: "Auswahl konnte nicht gespeichert werden. Bitte erneut versuchen.", } };

data.share = {
  button: "Ergebnis teilen",
  dialogTitle: "Ergebnis teilen",
  dialogSubtitle: "Erstelle ein Bild dieses Matches für Social Media. Es wird nichts hochgeladen — das Bild entsteht auf deinem Gerät.",
  showNames: "Namen der anderen Spieler anzeigen",
  showLocation: "Ort anzeigen",
  saveImage: "Bild speichern",
  shareImage: "Teilen",
  working: "Wird erstellt…",
  saved: "Bild gespeichert.",
  shared: "Geteilt.",
  failed: "Das Bild konnte nicht erstellt werden. Bitte versuche es erneut.",
  shareUnsupported: "Dieses Gerät kann keine Bilder teilen — nutze stattdessen „Bild speichern“.",
  you: "Du",
  yourTeam: "Dein Team",
  opponent: "Gegner",
  opposingTeam: "Gegnerisches Team",
  victory: "Sieg",
  defeat: "Niederlage",
  draw: "Unentschieden",
  retired: "Aufgabe",
  incomplete: "Unvollständig",
  retiredTag: "AUF.",
};

export default data;
